import {
  GET_RISK,
  GET_RISK_SUCCESS,
  GET_RISK_NO_ARCHIVE,
  GET_RISK_NO_ARCHIVE_SUCCESS,
  GET_RISK_BY_ID,
  GET_RISK_BY_ID_SUCCESS,
  POST_RISK,
  POST_RISK_SUCCESS,
  PATCH_RISK_BY_ID,
  PATCH_RISK_BY_ID_SUCCESS,
  DELETE_RISK_BY_ID,
  DELETE_RISK_BY_ID_SUCCESS,
  GET_RISK_BY_MAPPING_RISK_ID,
  GET_RISK_BY_MAPPING_RISK_ID_SUCCESS,
  SET_LIST_RISK_ASSOCIATED,
  // RISK RESIDUAL
  GET_RISK_RESIDUAL,
  GET_RISK_RESIDUAL_SUCCESS,
  GET_RISK_RESIDUAL_BY_ID,
  GET_RISK_RESIDUAL_BY_ID_SUCCESS,
  POST_RISK_RESIDUAL,
  POST_RISK_RESIDUAL_SUCCESS,
  PATCH_RISK_RESIDUAL_BY_ID,
  PATCH_RISK_RESIDUAL_BY_ID_SUCCESS,
  DELETE_RISK_RESIDUAL_BY_ID,
  DELETE_RISK_RESIDUAL_BY_ID_SUCCESS,
  //Mapping Risks
  GET_MAPPING_RISK,
  GET_MAPPING_RISK_SUCCESS,
  GET_MAPPING_RISK_BY_ID,
  GET_MAPPING_RISK_BY_ID_SUCCESS,
  GET_HISTORIC_OF_MAPPING_RISK_BY_ID,
  GET_HISTORIC_OF_MAPPING_RISK_BY_ID_SUCCESS,
  POST_MAPPING_RISK,
  POST_MAPPING_RISK_SUCCESS,
  PATCH_MAPPING_RISK_BY_ID,
  PATCH_MAPPING_RISK_BY_ID_SUCCESS,
  DELETE_MAPPING_RISK_BY_ID,
  DELETE_MAPPING_RISK_BY_ID_SUCCESS,
  // MATRICE DES RISQUES
  GET_MATRICE_RISK,
  GET_MATRICE_RISK_SUCCESS,
  GET_MATRICE_RISK_BY_ID,
  GET_MATRICE_RISK_BY_ID_SUCCESS,
  GET_FRENQUENCIES_AND_IMPACTS,
  GET_FRENQUENCIES_AND_IMPACTS_SUCCESS,
  GET_CALCUL_RISK_BRUT_RESULT,
  GET_CALCUL_RISK_BRUT_RESULT_SUCCESS,
  POST_MATRICE_RISK,
  POST_MATRICE_RISK_SUCCESS,
  PATCH_MATRICE_RISK_BY_ID,
  PATCH_MATRICE_RISK_BY_ID_SUCCESS,
  // ECHELLE DE CONFORMITE
  GET_CONFORMITY_SCALE,
  GET_CONFORMITY_SCALE_SUCCESS,
  GET_CONFORMITY_SCALE_BY_CONTROL,
  GET_CONFORMITY_SCALE_BY_CONTROL_SUCCESS,
  POST_CONFORMITY_SCALE,
  POST_CONFORMITY_SCALE_SUCCESS,
} from "./constants"
//******************************************************************************
//******************************* Risks ****************************************
//******************************************************************************

export const generateAction = (type, payload) => ({ type: type, payload: payload })

// GET
export function getRiskAction() {
  return {
    type: GET_RISK,
  }
}

export function getRiskSuccess(payload) {
  return {
    type: GET_RISK_SUCCESS,
    payload: payload,
  }
}
export function getRiskNoArchiveAction() {
  return {
    type: GET_RISK_NO_ARCHIVE,
  }
}

export function getRiskNoArchiveSuccess(payload) {
  return {
    type: GET_RISK_NO_ARCHIVE_SUCCESS,
    payload: payload,
  }
}

export function getRiskByIdAction(payload) {
  return {
    type: GET_RISK_BY_ID,
    payload: payload,
  }
}

export function getRiskByIdSuccess(payload) {
  return {
    type: GET_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function getRiskByMappingRiskIdAction(payload) {
  return {
    type: GET_RISK_BY_MAPPING_RISK_ID,
    payload: payload,
  }
}

export function getRiskByMappingRiskIdSuccess(payload) {
  return {
    type: GET_RISK_BY_MAPPING_RISK_ID_SUCCESS,
    payload: payload,
  }
}

export function setListRiskAssociatedAction(payload) {
  return {
    type: SET_LIST_RISK_ASSOCIATED,
    payload: payload,
  }
}
// POST
export function postRiskAction(payload) {
  return {
    type: POST_RISK,
    payload: payload,
  }
}

export function postRiskSuccess(payload) {
  return {
    type: POST_RISK_SUCCESS,
    payload: payload,
  }
}
// PATCH
export function patchRiskByIdAction(payload) {
  return {
    type: PATCH_RISK_BY_ID,
    payload: payload,
  }
}

export function patchRiskByIdSuccess(payload) {
  return {
    type: PATCH_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}
// DELETE
export function deleteRiskByIdAction(payload) {
  return {
    type: DELETE_RISK_BY_ID,
    payload: payload,
  }
}

export function deleteRiskByIdSuccess(payload) {
  return {
    type: DELETE_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}
//******************************************************************************
//******************************* RiskResiduals ********************************
//******************************************************************************
// GET
export function getRiskResidualAction() {
  return {
    type: GET_RISK_RESIDUAL,
  }
}

export function getRiskResidualSuccess(payload) {
  return {
    type: GET_RISK_RESIDUAL_SUCCESS,
    payload: payload,
  }
}

export function getRiskResidualByIdAction(payload) {
  return {
    type: GET_RISK_RESIDUAL_BY_ID,
    payload: payload,
  }
}

export function getRiskResidualByIdSuccess(payload) {
  return {
    type: GET_RISK_RESIDUAL_BY_ID_SUCCESS,
    payload: payload,
  }
}
// POST
export function postRiskResidualAction(payload) {
  return {
    type: POST_RISK_RESIDUAL,
    payload: payload,
  }
}

export function postRiskResidualSuccess(payload) {
  return {
    type: POST_RISK_RESIDUAL_SUCCESS,
    payload: payload,
  }
}
// PATCH
export function patchRiskResidualByIdAction(payload) {
  return {
    type: PATCH_RISK_RESIDUAL_BY_ID,
    payload: payload,
  }
}

export function patchRiskResidualByIdSuccess(payload) {
  return {
    type: PATCH_RISK_RESIDUAL_BY_ID_SUCCESS,
    payload: payload,
  }
}
// DELETE
export function deleteRiskResidualByIdAction(payload) {
  return {
    type: DELETE_RISK_RESIDUAL_BY_ID,
    payload: payload,
  }
}

export function deleteRiskResidualByIdSuccess(payload) {
  return {
    type: DELETE_RISK_RESIDUAL_BY_ID_SUCCESS,
    payload: payload,
  }
}
//******************************************************************************
//************************** Mapping Risks *************************************
//******************************************************************************
// GET
export function getMappingRiskAction() {
  return {
    type: GET_MAPPING_RISK,
  }
}

export function getMappingRiskSuccess(payload) {
  return {
    type: GET_MAPPING_RISK_SUCCESS,
    payload: payload,
  }
}

export function getMappingRiskByIdAction(payload) {
  return {
    type: GET_MAPPING_RISK_BY_ID,
    payload: payload,
  }
}

export function getMappingRiskByIdSuccess(payload) {
  return {
    type: GET_MAPPING_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}

export const getHistoricOfMappingRiskByIdAction = payload => {
  return generateAction(GET_HISTORIC_OF_MAPPING_RISK_BY_ID, payload)
}

export const getHistoricOfMappingRiskByIdSuccess = payload => {
  return generateAction(GET_HISTORIC_OF_MAPPING_RISK_BY_ID_SUCCESS, payload)
}

// POST
export function postMappingRiskAction(payload) {
  return {
    type: POST_MAPPING_RISK,
    payload: payload,
  }
}

export function postMappingRiskSuccess(payload) {
  return {
    type: POST_MAPPING_RISK_SUCCESS,
    payload: payload,
  }
}
// PATCH
export function patchMappingRiskByIdAction(payload) {
  return {
    type: PATCH_MAPPING_RISK_BY_ID,
    payload: payload,
  }
}

export function patchMappingRiskByIdSuccess(payload) {
  return {
    type: PATCH_MAPPING_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}
// DELETE
export function deleteMappingRiskByIdAction(payload) {
  return {
    type: DELETE_MAPPING_RISK_BY_ID,
    payload: payload,
  }
}

export function deleteMappingRiskByIdSuccess(payload) {
  return {
    type: DELETE_MAPPING_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}
//******************************************************************************
//************************** Matrice Risks *************************************
//******************************************************************************
// GET
export function getMatriceRiskAction(payload) {
  return {
    type: GET_MATRICE_RISK,
    payload: payload,
  }
}

export function getMatriceRiskSuccess(payload) {
  return {
    type: GET_MATRICE_RISK_SUCCESS,
    payload: payload,
  }
}

export function getMatriceRiskByIdAction(payload) {
  return {
    type: GET_MATRICE_RISK_BY_ID,
    payload: payload,
  }
}

export function getMatriceRiskByIdSuccess(payload) {
  return {
    type: GET_MATRICE_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function getFrequenciesAndImpactsAction(payload) {
  return {
    type: GET_FRENQUENCIES_AND_IMPACTS,
    payload: payload,
  }
}

export function getFrequenciesAndImpactsSuccess(payload) {
  return {
    type: GET_FRENQUENCIES_AND_IMPACTS_SUCCESS,
    payload: payload,
  }
}

export function getCalculRiskBrutResultAction(payload) {
  return {
    type: GET_CALCUL_RISK_BRUT_RESULT,
    payload: payload,
  }
}

export function getCalculRiskBrutResultSuccess(payload) {
  return {
    type: GET_CALCUL_RISK_BRUT_RESULT_SUCCESS,
    payload: payload,
  }
}
// POST
export function postMatriceRiskAction(payload) {
  return {
    type: POST_MATRICE_RISK,
    payload: payload,
  }
}

export function postMatriceRiskSuccess(payload) {
  return {
    type: POST_MATRICE_RISK_SUCCESS,
    payload: payload,
  }
}
// POST
export function patchMatriceRiskByIdAction(payload) {
  return {
    type: PATCH_MATRICE_RISK_BY_ID,
    payload: payload,
  }
}

export function patchMatriceRiskByIdSuccess(payload) {
  return {
    type: PATCH_MATRICE_RISK_BY_ID_SUCCESS,
    payload: payload,
  }
}
//******************************************************************************
//************************  Echelle de conformité ******************************
//******************************************************************************
// GET
export const getConformityScaleAction = payload => ({
  type: GET_CONFORMITY_SCALE,
  payload: payload,
})

export const getConformityScaleSuccessAction = payload => ({
  type: GET_CONFORMITY_SCALE_SUCCESS,
  payload: payload,
})

export const getConformityScaleByControlAction = payload => ({
  type: GET_CONFORMITY_SCALE_BY_CONTROL,
  payload: payload,
})

export const getConformityScaleByControlSuccessAction = payload => ({
  type: GET_CONFORMITY_SCALE_BY_CONTROL_SUCCESS,
  payload: payload,
})
// POST
export const postConformityScaleAction = payload => ({
  type: POST_CONFORMITY_SCALE,
  payload: payload,
})

export const postConformityScaleSuccessAction = payload => ({
  type: POST_CONFORMITY_SCALE_SUCCESS,
  payload: payload,
})
